import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "as-content-page" }
const _hoisted_2 = {
  key: 0,
  class: "as-py-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_tags = _resolveComponent("filter-tags")!
  const _component_StandingListSkeleton = _resolveComponent("StandingListSkeleton")!
  const _component_StandingList = _resolveComponent("StandingList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_filter_tags, {
        countries: _ctx.countries,
        tags: _ctx.tags,
        leagues: _ctx.leagues,
        sortBy: _ctx.sortBy,
        filter: _ctx.filter,
        onChangeLeague: _cache[0] || (_cache[0] = (newVal) => _ctx.changeLeague(newVal)),
        onChangeCountry: _cache[1] || (_cache[1] = (newVal) => _ctx.changeCountry(newVal))
      }, null, 8, ["countries", "tags", "leagues", "sortBy", "filter"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_StandingListSkeleton)
        ]))
      : (_openBlock(), _createBlock(_component_StandingList, {
          key: 1,
          standing: _ctx.standing,
          league: _ctx.filter.league,
          isPopup: false,
          onChangeSeason: _ctx.setSeason,
          class: "as-text-white"
        }, null, 8, ["standing", "league", "onChangeSeason"]))
  ], 64))
}